'use client'

import { useEffect, useState } from 'react'

import { selectCurrentProjectId, useProjectsStore } from '@modules/projects'

import { isGatewayReported } from '../utils/isGatewayReported'
import { shouldShowReportedStatus } from '../utils/shouldShowReportedStatus'

export type GatewayReportedStateSource = {
  name: string
  hostedModulesIds?: string[] | null
  hostedRuntimes?: string[] | null
}

export function useGatewayReportedState(gateway: GatewayReportedStateSource) {
  const currentProjectId = useProjectsStore(selectCurrentProjectId)
  const [openTelemetryConnected, setOpenTelemetryConnected] = useState(false)

  const hostedModulesCount = gateway.hostedModulesIds?.length ?? 0
  const hostedRuntimesCount = gateway.hostedRuntimes?.length ?? 0
  const hasHostedArtifacts = hostedModulesCount > 0 || hostedRuntimesCount > 0

  useEffect(() => {
    if (hasHostedArtifacts || !currentProjectId || !gateway.name) {
      return
    }

    let cancelled = false

    void isGatewayReported(currentProjectId, gateway.name).then((reported) => {
      if (!cancelled) {
        setOpenTelemetryConnected(reported)
      }
    })

    return () => {
      cancelled = true
    }
  }, [currentProjectId, gateway.name, hasHostedArtifacts])

  const hasReported = shouldShowReportedStatus({
    isReported: openTelemetryConnected,
    hostedModulesCount,
    hostedRuntimesCount,
  })

  return { hasReported, openTelemetryConnected }
}
